import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/blog/index.tsx")